import React, { Fragment, useState } from 'react';
import FindCourseClass from './FindCourse';
import CategoriesClass from './Categories';
import UpcomingClass from './UpcomingClass';
import { Row, Col } from 'reactstrap';
import { Btn } from '../../../AbstractElements';

const LearningFilter = () => {
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <Col xxl='3' xl='4' className='box-col-30 order-xl-2 order-1 '>
        <div className='md-sidebar job-sidebar'>
          <Btn onClick={(e) => setOpen(!open)} color='primary' className='md-sidebar-toggle'>
            learning filter
          </Btn>
          <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${open ? 'open' : ''}`}>
            <div className='default-according style-1 job-accordion' id='accordionoc'>
              <Row>
                <FindCourseClass />
                <CategoriesClass />
                <UpcomingClass />
              </Row>
            </div>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};

export default LearningFilter;
